import SplashPageLayout from "./SplashPageLayout";

export default SplashPageLayout;
